const uk = {
  common: {
    loading: "Завантаження...",
    close: "Закрити",
    submit: "Надіслати",
    review: "огляд",
    help: "Довідка",
    tour: "Тур",
    instructions: "Інструкції",
    language: "Мова",
    ok: "добре",
    appLoaderText:
      "Завантаження... Будь ласка, зачекайте, поки ми готуємо ваше середовище оцінювання."
  },
  assessment: {
    fetchError: "Помилка отримання {{featureName}}",
    somethingWentWrong: "Щось пішло не так.",
    goBackToDashboard: "Поверніться до інформаційної панелі",
    confirmSubmissionTitle: "Підтвердити подання",
    scheduleIdNotFound: "Ідентифікатор розкладу не знайдено",
    ongoingIdNotFound: "Поточний ідентифікатор не знайдено",
    errorFetchingOngoingData: "Помилка отримання поточних даних",
    connectionRestoredLabel: "З'єднання відновлено.",
    connectionRestoredDescription: "Ви можете продовжити виконання тестів.",
    connectionLostLabel: "Ми втратили з’єднання з тестовим сервером.",
    connectionLostDescription:
      "Зараз ви не зможете запустити або перевірити тестові випадки.",
    featureNames: {
      assessment: "Оцінка",
      knowledgeCheck: "Перевірка знань"
    },
    cardStatus: {
      na: "Н/Д",
      toBeLaunched: "Ще не розпочато",
      expired: "Завершено",
      expiringSoon: "Незабаром завершиться",
      ongoing: "Триває"
    },
    cardState: {
      draft: "Чернетка",
      published: "Опубліковано",
      cancelled: "Скасовано",
      inreview: "На перевірці",
      readytopublish: "Готово до публікації",
      sentback: "Повернено"
    },
    dashboard: {
      videoProctoring: "Відеопрокторінг",
      submitFeature: "Надіслати {{featureName}}",
      noSectionsFound: "Розділи не знайдено",
      expandAllSections: "Розгорніть усі розділи",
      closeAllSections: "Закрити всі розділи",
      continueShapingAssessments: "Продовжуйте формувати свої оцінювання",
      viewAll: "Переглянути все",
      legend: {
        notStarted: "Не розпочато",
        inProgress: "В роботі",
        completed: "Виконано"
      }
    },
    confirmModal: {
      description:
        "Після надсилання ви не зможете вносити жодних змін у свій {{featureName}}. Перегляньте свої відповіді перед підтвердженням. Ви бажаєте продовжити подання?",
      lowWordCountWarning:
        "Ваша відповідь на запитання {{questionTitle}} містить менше 40 слів. Якщо ви подасте оцінку зараз, ця відповідь не буде збережена.",
      videoNotSubmittedWarning:
        "Ваше записане відео для запитання {{questionTitle}} не надіслано. Надсилання оцінки зараз відхилить цю відповідь.",
      unansweredQuestions: "У вас є {{count}} запитань без відповіді",
      andFlaggedQuestions: "і {{count}} позначених запитань",
      failedToFinish: "Не вдалося завершити {{featureName}}"
    },
    feedback: {
      submittedTitle: "Вашу {{featureName}} успішно надіслано!",
      submittedDescription:
        "Ваші відповіді надіслано. Ми цінуємо ваш час і зусилля, щоб завершити цю {{featureName}}!",
      resultInProgress:
        "Результат обчислюється, і це може зайняти до хвилини. Будь ласка, зачекайте...",
      resultReady:
        "Результат готовий! Натисніть кнопку «Показати результат», щоб переглянути його.",
      resultDelayed:
        "Розрахунок результату займає більше часу, ніж зазвичай. Будь ласка, зв'яжіться з адміністратором для отримання результату.",
      showResult: "Показати результат",
      redirectingToResult:
        "Переспрямування на сторінку результатів через {{seconds}} секунд, якщо ви не натиснете кнопку «Показати результат»",
      shareFeedbackTitle: "Поділіться своїм відгуком",
      shareFeedbackDescription:
        "Ваше розуміння прокладає шлях для зростання. Давайте підвищуватись разом!",
      errorSubmittingFeedback: "Помилка надсилання відгуку",
      feedbackSubmittedTitle: "Все готово, відгук надіслано!",
      feedbackSubmittedDescription:
        "Ваш відгук надіслано. Дякуємо, що допомагаєте нам покращувати роботу {{featureName}}!",
      feedbackAlreadySubmittedTitle: "Все готово, відгук уже надіслано!",
      feedbackAlreadySubmittedDescription:
        "Схоже, ви вже надіслали відгук. Дякуємо, що допомагаєте нам покращувати роботу {{featureName}}!"
    },
    page: {
      errorFetchingPreAssessmentData:
        "Помилка отримання даних попереднього оцінювання",
      connectionRestoredLabel: "З'єднання відновлено.",
      connectionRestoredDescription: "Синхронізація останніх змін...",
      offlineLabel: "Схоже, ви офлайн.",
      offlineDescription:
        "Зміни не синхронізуються, доки ви не підключитесь повторно"
    },
    question: {
      questions: "Питання",
      closeQuestionsPanel: "Закрити панель питань",
      collapse: "Згорнути",
      sectionSummary: "Підсумок розділу",
      sections: "Розділи",
      toggleQuestionsPanel: "Перемкнути панель питань",
      switchModal: {
        switchQuestionButton: "Переключити питання",
        leaveHeading: "Ви впевнені, що хочете піти?",
        discardMessage:
          "У вас є незбережені зміни. Якщо ви зміните запитання, вашу відповідь буде остаточно видалено.",
        saveChangesButton: "Зберегти зміни",
        saveHeading: "Бажаєте зберегти зміни?",
        saveBeforeSwitchMessage:
          "У вас є незбережені зміни. Бажаєте зберегти їх перед зміною запитання?"
      }
    },
    faq: {
      q1: {
        question: "Що я повинен зробити перед початком {{featureName}}?",
        firstSentence: "Переконайтеся, що ви виконали наступне:",
        list: {
          item1: "Стабільне підключення до Інтернету",
          item2:
            "Працююча веб-камера та мікрофон (якщо увімкнено відеопрокторінг)",
          item3: "Тихе середовище без відволікань",
          item4:
            "Якщо відеопрокторінг увімкнено, вам буде запропоновано завершити перевірку системи.",
          item5: "Прочитайте та погодьтеся з положеннями та умовами"
        }
      },
      q2: {
        question:
          "Чи можу я переходити між запитаннями чи розділами під час {{featureName}}?",
        firstSentence: "Навігація залежить від налаштувань.",
        list: {
          item1:
            "Якщо навігацію по розділах увімкнено, ви можете переходити між розділами.",
          item2:
            "Якщо вимкнено, вам потрібно буде завершити один розділ, перш ніж переходити до наступного."
        },
        lastSentence:
          "Інструкції будуть доступні протягом усього {{featureName}}."
      },
      q3: {
        question: "Чи будуть за мною спостерігати під час тестування?",
        list: {
          item1:
            "Якщо на цьому {{featureName}} ввімкнено захист відео, використовуватимуться ваша камера та мікрофон.",
          item2:
            "Будь-яка незвична діяльність може бути позначена для перевірки."
        }
      },
      q4: {
        question:
          "Що станеться, якщо я втрачу з’єднання з Інтернетом або випадково закрию браузер?",
        firstSentence: "Ваш прогрес зберігається автоматично.",
        lastSentence:
          "Якщо трапиться відключення, ви можете знову приєднатися до {{featureName}} за тим самим посиланням."
      },
      q5: {
        question: "Чи побачу я свої результати чи відгук після тесту?",
        firstSentence:
          "Результати та відгуки налаштовуються організатором {{featureName}}.",
        list: {
          item1:
            "Якщо ввімкнено, ви побачите свій бал і підсумок відгуків після надсилання.",
          item2:
            "Якщо ні, ваші результати будуть надіслані на вашу зареєстровану електронну адресу."
        }
      }
    },
    labels: {
      totalDuration: "Загальна тривалість",
      numberOfQuestions: "Кількість питань",
      numberOfSections: "Кількість розділів",
      guidelines: "Настанови",
      platformHelp: "Довідка платформи",
      faq: "FAQ",
      frequentlyAskedQuestions: "Часті запитання",
      showFeatureInstructions: "Показати інструкції {{featureName}}",
      minutes: "хвилин",
      welcome: "Ласкаво просимо",
      welcomeBack: "Ласкаво просимо назад",
      userFallback: "Користувач",
      defaultGuidelines:
        "Перш ніж почати {{featureName}}, переконайтеся, що ви перебуваєте в тихому місці, де вас не відволікає, зі стабільним підключенням до Інтернету. Тримайте камеру ввімкненою під час тестування та розумно розподіляйте час, оскільки існує обмеження за часом. Якщо у вас виникли будь-які технічні проблеми, негайно зверніться до служби підтримки. Закінчивши, перегляньте свої відповіді перед надсиланням. удачі!"
    },
    zoom: {
      textSize: "Розмір тексту:",
      decreaseTextSize: "Зменшити розмір тексту (A-)",
      resetTextSize: "Скинути розмір тексту (A)",
      increaseTextSize: "Збільшити розмір тексту (A+)",
      decreaseInterfaceSize: "Зменшити розмір інтерфейсу",
      resetInterfaceSize: "Скинути розмір інтерфейсу",
      increaseInterfaceSize: "Збільшити розмір інтерфейсу"
    },
    wrapper: {
      warningTitle: "УВАГА!",
      stayOnPageMessage:
        "Залишайтеся на цій сторінці, доки не завершите {{featureName}}.",
      iUnderstand: "Я розумію",
      submitTheFeature: "Надіслати {{featureName}}",
      videoProctoringInterrupted: "Огляд відео перервано",
      continuationBlocked:
        "Продовження оцінювання заблоковано, доки не буде відновлено безпечний захист відео.",
      retryProctoring: "Повторити прокторінг"
    },
    progress: {
      proceed: "Продовжуйте",
      resumeFeature: "Продовжити {{featureName}}",
      timeRemainingMessage:
        "залишився в {{featureName}}. Натисніть нижче, щоб продовжити з того місця, де ви зупинилися.",
      continueOnThisDevice: "Продовжити на цьому пристрої?",
      switchToThisTab: "Перейти на цю вкладку?",
      continueYourAssessmentHere: "Продовжити оцінювання тут?",
      switchHere: "Перейти сюди",
      attemptsUnlimited:
        "У вас є необмежена кількість спроб для цього оцінювання.",
      attemptsSingle: "У вас є <strong>1</strong> спроба для цього оцінювання.",
      attemptsMultiple:
        "У вас є <strong>{{remainingAttempts}}</strong> з <strong>{{maxAttempts}}</strong> доступних спроб для цього оцінювання.",
      coolOffAfterAttempt:
        "Після кожної спроби вам потрібно зачекати <strong>{{coolOffTime}}</strong>, перш ніж почати наступну спробу."
    },
    loginWindow: {
      expiredTitle: "Час входу минув",
      expiredMessage:
        "Вікно входу для цього {{featureName}} закрито. Ви пропустили відведений час для доступу до тесту."
    },
    coding: {
      saving: "Збереження",
      offlineTitle: "Схоже, ви офлайн",
      offlineDescription:
        "Зміни не синхронізуються, доки ви не підключитесь повторно",
      connectionRestored: "З'єднання відновлено",
      syncingLatest: "Синхронізація останніх змін...",
      autoSaveEnabled: "Автоматичне збереження ввімкнено",
      runOnlyChecksDescription: "лише перевіряє ваш код за тест-кейсами.",
      submitEvaluationDescription:
        "свій код, щоб його оцінили та ви отримали бали.",
      reset: "Скинути",
      run: "Запустити",
      runTests: "Виконання тестів",
      submit: "Надіслати",
      submitting: "Подання",
      resetCode: "Скинути код",
      resetCodeMessage:
        "Ви впевнені, що хочете скинути? Це видалить увесь поточний код і відновить початковий код",
      testCases: "Тестові випадки",
      testCase: "Тестовий приклад {{index}}",
      testCasePassed: "Тестовий приклад пройдено",
      testCaseFailed: "Тестовий приклад не виконано",
      runtimeError: "Помилка виконання",
      timeLimitExceeded: "Час перевищено",
      timeLimitExceededTitle: "Час перевищено",
      timeLimitExceededDescription:
        "Ваш код не виконано в межах часу. Будь ласка, оптимізуйте свій код.",
      input: "Введення",
      expectedOutput: "Очікуваний результат",
      yourOutput: "Ваш результат",
      hiddenTestCase: "Прихований тестовий приклад",
      hiddenTestCaseDescription:
        "Приховані тестові випадки використовуються для оцінки того, чи може ваш код обробляти різні сценарії, включаючи кутові випадки",
      explanation: "Пояснення",
      hints: "Підказки"
    },
    subjective: {
      minWordsRequired: "Щоб подати відповідь, потрібно мінімум 40 слів.",
      enterYourAnswer: "Введіть свою відповідь",
      submitResponse: "Надіслати відповідь",
      submittingResponse: "Надсилання відповіді...",
      resetAnswer: "Скинути відповідь",
      resetAnswerMessage:
        "Ви впевнені, що хочете скинути? Вашу поточну відповідь буде видалено назавжди.",
      retake: "Перезняти",
      showHint: "Показати підказку",
      recording: "ЗАПИС"
    },
    systemCheck: {
      calibrate: "Відкалібрувати",
      calibrating: "Калібрування...",
      accessDenied: "Доступ заборонено",
      cameraPermissionDenied:
        "Відмовлено в дозволі для камери. Щоб продовжити, увімкніть доступ до камери в налаштуваннях браузера.",
      errorFetchingDevices: "Помилка отримання пристроїв",
      failedToStartAssessment: "Не вдалося почати оцінювання",
      unableToStartSecureProctoring:
        "Зараз неможливо запустити безпечний нагляд. Будь ласка, повторіть спробу.",
      unnamedCamera: "Камера без назви",
      facingCalibrationIssues: "Виникли проблеми з калібруванням відео?",
      lookAtCenter: "Будь ласка, подивіться в центр екрана та не рухайтеся.",
      unableToCalibrateTitle:
        "Не можете відкалібрувати камеру для відеопрокторінгу?",
      statusMessages: {
        readyForCalibration:
          "Переконайтеся, що ваше обличчя чітко видно та знаходиться в центрі екрана. Коли будете готові, натисніть «Калібрувати», щоб почати.",
        calibratingInProgress:
          "Виконується калібрування. Продовжуйте дивитися на екран.",
        calibratingTimedOut:
          "Час очікування калібрування камери минув. Щоб продовжити, оновіть браузер.",
        preparingCameraPreview:
          "Підготовка потоку камери та відстеження обличчя для калібрування.",
        retryRequired:
          "Перед тим, як продовжити налаштування прокторінгу, потрібно виконати вашу дію.",
        proctoringUnavailable:
          "Прокторінг наразі недоступний, і оцінювання не може розпочатися безпечно.",
        calibrationCompleted:
          "Калібрування успішне! Ви готові почати оцінювання.",
        timeoutHelp:
          "Якщо ви все ще бачите це повідомлення, перевірте наявність інших вкладок/програм за допомогою камери або зовнішнього затвора."
      },
      failureReasons: {
        cameraPermissionDenied:
          "Дозвіл камери заблоковано. Дозвольте доступ і повторіть спробу.",
        cameraUnavailable:
          "Камера недоступна. Перевірте свій вибір пристрою та повторіть спробу.",
        facemeshInitFailed:
          "Не вдалося налаштувати відстеження обличчя. Спробуйте продовжити.",
        cocoLoadFailed:
          "Механізм захисту недоступний. Оновіть і повторіть спробу.",
        streamLostReacquireFailed:
          "Не вдалося відновити потік камери. Повторити прокторінг.",
        calibrationInsufficientData:
          "Калібрувальних зразків було недостатньо. Повторіть калібрування.",
        detectionCadenceUnavailable:
          "Конфігурація часу не готова. Повторіть незабаром."
      },
      calibrationInfo: {
        heading: "Щоб успішно відкалібрувати відео, виконайте такі дії:",
        followUpHeading:
          "Якщо проблема не зникає, виконайте наведені нижче дії.",
        initialSteps: {
          step1: {
            title: "Забезпечте хороше освітлення",
            description:
              "Сядьте в добре освітлене місце, щоб добре було видно ваше обличчя. Уникайте яскравого світла або вікон за спиною."
          },
          step2: {
            title: "Дивіться прямо в камеру",
            description:
              "Розташуйте своє обличчя в центрі кадру та дивіться прямо в камеру під час калібрування."
          },
          step3: {
            title: "Уникайте темного або розмитого фону",
            description: "Переконайтеся, що фон чіткий і не надто темний."
          },
          step4: {
            title: "Перевірте дозволи камери",
            description:
              "Дозвольте своєму браузеру отримати доступ до веб-камери, коли буде запропоновано."
          },
          step5: {
            title: "Не рухайтесь і дивіться на екран",
            description:
              "Під час калібрування тримайте голову нерухомо, щоб допомогти системі правильно визначити ваше обличчя."
          }
        },
        laterSteps: {
          step1:
            "Спробуйте оновити сторінку та повторно відкалібрувати камеру.",
          step2:
            "Закрийте інші програми за допомогою веб-камери (наприклад, Zoom або Teams).",
          step3:
            "Якщо проблема не зникне, зв’яжіться з {{contactEmail}} і надішліть знімок екрана з помилкою."
        }
      }
    },
    stepper: {
      termsAndConditions: "Правила та умови",
      agreeTerms: "Я прочитав і погоджуюся з положеннями та умовами.",
      previousStep: "Попередній крок",
      nextStep: "Наступний крок",
      startAssessment: "Розпочати оцінювання",
      resumeAssessment: "Продовжити оцінювання",
      mediaCheck: "Перевірка медіа",
      systemCheck: "Перевірка системи",
      audioCheck: {
        intro:
          "Тут ви можете записати коротке відео, щоб перевірити, чи камера та мікрофон працюють належним чином.",
        mediaPermissionDenied:
          "Доступ до камери або мікрофона заборонено. Будь ласка, увімкніть дозволи в налаштуваннях браузера.",
        startRecording: "Почати запис",
        stopRecording: "Зупинити запис",
        unnamedMicrophone: "Мікрофон без назви"
      },
      stepLabel: "КРОК {{step}}",
      personalDetails: "Особисті дані",
      emailId: "ID електронної пошти",
      firstName: "Ім'я",
      lastName: "Прізвище",
      defaultTncStatement:
        "Беручи участь у цьому оцінюванні, ви підтверджуєте, що відповідаєте вимогам відповідності, визначеним компанією, і погоджуєтеся пройти тест самостійно, без сторонньої допомоги. Оцінка підлягає відеоспостереженню, і ви повинні мати свою камеру протягом усього сеансу в середовищі, що не відволікає увагу. Увесь вміст і матеріали, надані під час оцінювання, є конфіденційними, і їх заборонено передавати, відтворювати чи поширювати. Ви погоджуєтеся дотримуватися встановленого терміну оцінювання; ненадання до закінчення терміну може призвести до дискваліфікації. Компанія не несе відповідальності за будь-які технічні проблеми, пов’язані з вашим підключенням до Інтернету, програмним або апаратним забезпеченням. Персональні дані, зібрані під час оцінювання, оброблятимуться лише для цілей оцінювання та найму відповідно до політики конфіденційності компанії. Будь-яка спроба обману, плагіату чи іншої неетичної поведінки призведе до негайної дискваліфікації. Надсилаючи свої відповіді, ви підтверджуєте, що вони остаточні, і жодні зміни після надсилання не можуть бути внесені. Компанія залишає за собою право змінювати або оновлювати ці умови в будь-який час, і учасники будуть повідомлені про будь-які істотні зміни.",
      okay: "Гаразд"
    },
    access: {
      cancelledTitle: '"{{title}}" скасовано',
      cancelledDescription:
        "Ця оцінка більше не активна, і до неї неможливо отримати доступ. Будь ласка, перегляньте на своїй інформаційній панелі інші призначені або майбутні оцінювання.",
      goToHome: "Перейдіть на головну сторінку",
      refreshPage: "Оновити сторінку"
    },
    errorPage: {
      goBack: "Назад",
      raiseRequest: "Створити запит",
      retryLogin: "Увійти знову",
      contactUs: "Зв'яжіться з нами",
      goBackToEvent: "Повернутися до події",
      launchCourse: "Запустити курс",
      created: "Створено",
      starts: "Початок",
      ends: "Завершення",
      untitled: "Без назви"
    },
    sidebar: {
      home: "Головна",
      quickAccess: "Швидкий доступ",
      questionPaperAuthoring: "Створення тестів",
      assessmentLibrary: "Бібліотека оцінювань",
      scheduleInterview: "Запланувати співбесіду",
      generateQuestions: "Згенерувати запитання",
      roleManagement: "Керування ролями",
      logout: "Вийти",
      noAccess: "Немає доступу",
      noAccessWithLabel: "{{label}} (Немає доступу)",
      noAccessToLink: "Ви не маєте доступу до цього посилання",
      expandSidebar: "Розгорнути бічну панель",
      collapseSidebar: "Згорнути бічну панель",
      expand: "Розгорнути",
      collapse: "Згорнути",
      myPreferences: "Мої налаштування"
    },
    timesUp: {
      title: "Час оцінки завершено",
      autoSubmittedMessage:
        "Таймер закінчився. Ваші відповіді збережено, а {{featureName}} надіслано автоматично."
    },
    resultCard: {
      title: "{{featureName}} Результати",
      score: "Оцінка",
      passPercentage: "Прохідний відсоток",
      marksAway:
        "Вам залишилося {{count}} балів до сертифікації. Зосередьтеся на рекомендованих областях і повторіть спробу.",
      certificationEarned:
        "Ви перевищили вимоги сертифікації та отримали сертифікацію",
      congratulationsOnEarning:
        "Вітаємо з отриманням сертифіката {{featureName}}",
      almostThereTitle: "Ви ближче, ніж думаєте, до отримання сертифіката",
      certificatePassedDescription:
        "Ви продемонстрували знання та навички, необхідні для отримання цієї сертифікації. Знайдіть хвилинку, щоб відсвяткувати це досягнення та поділитися ним зі своєю мережею",
      certificateFailDescription:
        "Ця спроба підкреслила можливості зміцнити свої навички. Перегляньте рекомендовані райони та сміливо повертайтеся",
      congratsImageAlt: "Вітаємо зображення",
      almostThereImageAlt: "Майже готово Зображення"
    },
    sectionCard: {
      section: "Розділ",
      startSection: "Почати розділ",
      continueSection: "Продовжити розділ",
      completed: "Виконано",
      viewSection: "Переглянути розділ",
      totalQuestions: "Загальна кількість запитань:",
      sectionNotFound: "Розділ не знайдено.",
      total: "Всього",
      flagged: "Позначено"
    },
    sectionSummary: {
      totalQuestions: "Загальна кількість запитань",
      completedQuestions: "Завершені запитання",
      flaggedQuestions: "Позначені запитання",
      unattemptedQuestions: "Запитання без спроби",
      codingQuestions: "Питання щодо кодування:",
      objectiveQuestions: "Об'єктивні питання:",
      goToSections: "Перейти до розділів",
      lowWordCountWarning:
        "Ваша відповідь на запитання {{questionTitle}} містить менше 40 слів. Якщо ви повернетеся до списку розділів, цю відповідь буде відхилено.",
      videoNotSubmittedWarning:
        "Ваше записане відео для запитання {{questionTitle}} не надіслано. Якщо ви повернетеся до списку розділів, цю відповідь буде відхилено."
    },
    objective: {
      questionCounter: "Питання",
      marks: "Знаки:",
      explanation: "Пояснення",
      hints: "Підказки",
      reset: "Скинути",
      flag: "Прапор",
      unflag: "Зняти прапорець",
      previous: "Попередній",
      saveAndNext: "Зберегти й далі",
      saveAndViewSummary: "Зберегти та переглянути підсумок розділу",
      next: "Далі",
      viewSectionSummary: "Переглянути резюме розділу",
      hideExplanation: "Приховати пояснення",
      showExplanation: "Показати пояснення",
      hintWaitTooltip:
        "Вам потрібно зачекати, перш ніж ви побачите ще одну підказку",
      noHintsPendingTooltip: "Жодних підказок немає",
      selectOptionForExplanation:
        "Виберіть опцію, щоб переглянути пояснення вибраної опції"
    },
    tour: {
      shared: {
        timer:
          "Цей таймер показує час, що залишився для вашого оцінювання. Будь ласка, уважно стежте за цим, щоб переконатися, що ви завершили всі розділи протягом відведеного часу.",
        submit:
          "Після завершення всіх розділів оцінювання ви можете подати свою роботу, натиснувши кнопку «Надіслати оцінку». Ця дія завершує ваші відповіді, і ви більше не зможете вносити зміни після надсилання. Переконайтеся, що ви переглянули всі свої відповіді, перш ніж продовжити надсилання."
      },
      dashboard: {
        legend:
          "Легенда стану розділу допомагає зрозуміти ваш прогрес під час оцінювання. Він використовує чіткі індикатори, щоб показати, чи розділ ще не розпочато, чи виконується наразі, чи завершено. Це дає змогу швидко оцінити, які частини все ще потребують вашої уваги, і ефективно розподіляти свій час.",
        sectionCard:
          "Картка розділу містить детальний огляд кожного розділу оцінювання. Він відображає назву розділу, його поточний статус і ключову інформацію про запитання в цьому розділі. Це включає загальну кількість запитань, кількість позначених питань і кількість запитань, які було виконано. Картка розділу допомагає відстежувати ваш прогрес і визначати сфери, які можуть потребувати більше уваги."
      },
      coding: {
        titles:
          "У верхній частині сторінки ви побачите чітке відображення заголовка оцінювання та заголовка розділу. Це допоможе вам відстежувати ваше поточне завдання та гарантує, що ви знаєте про конкретний розділ, над яким працюєте. Зверніться до цих заголовків, щоб зорієнтуватися під час перегляду запитань.",
        sectionsButton:
          "Ця кнопка дає змогу легко повернутися до інформаційної панелі розділів. Використовуйте його, щоб повернутися до основного огляду вашого оцінювання, де ви можете переглядати та керувати прогресом усіх розділів. Це забезпечує швидкий спосіб переоцінити ваш загальний прогрес, не втрачаючи жодної з поточної роботи.",
        sidebar:
          "Бічна панель містить огляд усіх запитань у поточному розділі, який ви намагаєтеся відкрити. Це дозволяє швидко переходити між питаннями, просто вибираючи відповідний блок. Кожен блок запитань позначено кольором залежно від його статусу, що дозволяє легко відстежувати ваш прогрес і за потреби переходити до конкретних питань.",
        questionCard:
          "Ця картка містить запитання, над яким ви зараз працюєте, повну підказку та будь-які відповідні інструкції чи вимоги до введення. Його створено, щоб дати вам чітке уявлення про поставлене завдання з усією необхідною інформацією для продовження. Ви також знайдете кнопку, щоб позначити запитання для подальшого перегляду, що дозволить вам легко повернутися до нього, якщо потрібно. Крім того, є кнопки навігації, які дозволяють переходити до наступного чи попереднього запитання, не повертаючись до бічної панелі, забезпечуючи плавне та ефективне проходження оцінювання.",
        editor:
          "У редакторі коду ви будете писати та змінювати свої рішення. Ви можете перемикатися між різними мовами програмування відповідно до вимог кожного питання. Крім того, у вас є можливість налаштувати тему редактора для більш зручного кодування. Якщо ви віддаєте перевагу більшому простору на екрані, редактор можна розгорнути на всю ширину, надаючи вам більшу область для роботи. Ці функції розроблено для забезпечення гнучкого та зручного середовища під час виконання завдань програмування."
      }
    },
    toast: {
      proctoringViolationDetected: "Виявлено порушення прокторінгу",
      messages: {
        forbiddenObjectDetected: "Виявлено заборонений об'єкт",
        noFaceDetected: "Обличчя не виявлено",
        multipleFacesDetected: "Виявлено кілька облич",
        lookingAwayFromScreen: "Відводити погляд від екрану",
        notLookingAtScreen: "Не дивлячись на екран",
        faceNotOrientedCorrectly: "Обличчя орієнтоване неправильно",
        eyesNotFullyOpen: "Очі не повністю відкриті",
        copyNotAllowed: "Копіювання заборонено",
        cutRestricted: "Різання обмежено в режимі контролю",
        pasteNotAllowed: "Склеювання не допускається",
        contextMenuNotAllowed: "Відкриття контекстного меню заборонено"
      }
    },
    whatsNext: {
      heading: "Що далі?",
      attemptsRemaining: "залишилося спроб",
      passed: {
        shareLinkedInTitle: "Поділіться на LinkedIn",
        shareLinkedInSubtitle:
          "Святкуйте свої досягнення разом зі своєю професійною мережею.",
        viewCertificateTitle: "Переглянути сертифікат",
        viewCertificateSubtitle:
          "Завантажте або отримайте доступ до своєї сертифікації в будь-який час.",
        shareGloTitle: "Поділіться досвідом",
        shareGloSubtitle:
          "Надихайте колег, публікуючи свої досягнення всередині компанії."
      },
      failed: {
        reviewLearningResourcesTitle: "Перегляньте навчальні ресурси",
        reviewLearningResourcesSubtitle:
          "Зміцнюйте навички, які потребують уваги.",
        retakeAssessmentTitle: "Повторно пройти оцінювання",
        retakeAssessmentSubtitle:
          "Продемонструйте свій прогрес і оновлене розуміння."
      },
      modal: {
        title: "Поділіться досягненням",
        linkedInPostLabel: "Поділіться на LinkedIn як публікація",
        linkedInProfileLabel: "Додати як сертифікат до профілю LinkedIn",
        gloLabel: "Поділитися на Glo",
        comingSoon: "Скоро буде",
        infoMessage: "Ви повинні увійти на платформу, щоб поділитися."
      }
    },
    time: {
      hour_one: "{{count}} година",
      hour_other: "{{count}} год",
      minute_one: "{{count}} хвилина",
      minute_other: "{{count}} хвилин",
      hourShort: "год",
      minuteShort: "хв",
      secondShort: "с"
    },
    accessScreens: {
      attemptResultProcessing: {
        alt: "{{featureName}} результати обробляються",
        title: "Ваші результати обробляються",
        description:
          "Ми все ще перевіряємо вашу {{featureName}}. Перевірте незабаром!"
      },
      coolOffPeriod: {
        alt: "Період охолодження",
        title: "Наступна спроба незабаром",
        completedAttempt: "Ви вже завершили спробу для цього",
        nextAttemptIntro: ". Ваша наступна спроба буде доступна через"
      },
      maxAttemptExceeded: {
        alt: "Досягнуто максимальної кількості спроб",
        title: "Досягнуто максимальної кількості спроб",
        description:
          "Ви використали всі доступні спроби для цього {{featureName}}. Подальші спроби робитися не можуть."
      },
      scheduleNotStarted: {
        alt: "Розклад не розпочато",
        title: "{{featureName}} Ще не розпочато",
        scheduledPrefix: "The",
        scheduledOn: "заплановано на початок",
        checkBack:
          "Будь ласка, перевірте ще раз у {{time}} або оновіть, коли час почнеться."
      },
      scheduleTimeCompleted: {
        alt: "Розклад виконано",
        title: "{{featureName}} Вікно закрито",
        description:
          "Запланований час для цього {{featureName}} минув. Ви більше не можете почати або зробити спробу."
      }
    },
    attemptDetails: {
      allAttempts: "Всі спроби",
      headers: {
        attempt: "Спроба",
        attemptedOn: "Замах на",
        percentage: "Відсоток"
      },
      viewAllAttempts: "Переглянути всі спроби"
    },
    survey: {
      questions: {
        q1: "Наскільки зрозумілими вам були запитання {{featureName}} за шкалою від 1 до 5?",
        q2: "Я відчував себе достатньо підготовленим до тем, які обговорювалися в {{featureName}}",
        q3: "Платформа, використана для {{featureName}}, була зручною та функціональною",
        q4: "Я вважаю, що мої відповіді ефективно продемонстрували мої навички та знання"
      },
      stronglyDisagree: "Категорично не згоден",
      stronglyAgree: "Цілком згоден",
      submitFeedback: "Надіслати відгук"
    },
    cameraPreview: {
      loadingAlt: "Завантаження попереднього перегляду камери",
      delayedMessage:
        "Через повільну мережу калібрування триває довше, ніж очікувалося. Зачекайте або спробуйте оновити сторінку."
    },
    proctoring: {
      engineLoadFailedStatus: "Не вдалося завантажити механізм Proctoring",
      runtimeErrors: {
        cameraPermissionDenied:
          "Доступ до камери заблоковано налаштуваннями дозволу браузера.",
        cameraUnavailable:
          "Камера недоступна або зараз використовується іншою програмою.",
        unableToLoadModel:
          "Не вдалося завантажити модель виявлення об’єкта захисту.",
        webglRecoveryFailed:
          "Не вдалося відновити WebGL під час відновлення виявлення об’єкта."
      },
      logs: {
        engineLoadFailed: "ProctoringEngine не вдалося завантажити:",
        videoPlayRejected: "Video play() відхилено:",
        cameraTrackEnded:
          "Відстеження камери закінчено – спроба повторного отримання",
        cameraReacquired: "Камера повторно отримана під час спроби {{attempt}}",
        cameraReacquireAttemptFailed:
          "Спроба повторного захоплення камери {{attempt}} не вдалася:",
        cameraReacquireFailedAll:
          "Повторне отримання камери не вдалось після всіх спроб - повідомляється про відключення камери кожного циклу",
        uploadFailedQueued:
          "Помилка завантаження захисту після {{attempts}} спроб, у черзі на повторну спробу:",
        uploadAttemptFailedRetrying:
          "Спроба захисту від завантаження {{attempt}} не вдалася, повторна спроба...",
        drainedQueuedViolation:
          "Злито порушення черги: {{violationType}} (залишилося {{remaining}})",
        queueDrainFailed:
          "Помилка зливу черги, повторна спроба наступного циклу:",
        cocoLoadFailed: "Помилка завантаження COCO-SSD:",
        faceProcessingError: "Помилка обробки обличчя:",
        errorProcessingFrame: "Помилка обробки кадру:",
        faceMeshInitError: "Помилка ініціалізації Face Mesh:"
      }
    }
  }
} as const;

export default uk;
